module.exports = __webpack_public_path__ + "static/scoring-1-e3793dd3b466a0654c88b062363f7b97.svg";